var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '../../../../styles/styled';
import Button from '../../../Button';
const List = styled.ol `
  list-style: none;
  display: flex;
  justify-content: center;
`;
const buttonStyles = ({ theme }) => css `
  min-width: 34px;
  padding: ${theme.spacings.bit};
  margin-right: ${theme.spacings.bit};

  li:last-child & {
    margin-right: 0;
  }
`;
const PageButton = styled(Button)(buttonStyles);
export const PageList = (_a) => {
    var { onChange, pageLabel, pages, currentPage } = _a, props = __rest(_a, ["onChange", "pageLabel", "pages", "currentPage"]);
    return (_jsx(List, Object.assign({ role: "list" }, props, { children: pages.map((page) => {
            const isCurrent = currentPage === page;
            const label = pageLabel(page);
            return (_jsx("li", { children: _jsx(PageButton, Object.assign({ size: "kilo", onClick: () => onChange(page), variant: isCurrent ? 'primary' : 'tertiary', title: label, "aria-label": label, "aria-current": isCurrent }, { children: page })) }, page));
        }) })));
};
